import React from 'react'

import { Select } from '@runeffective/evo-design-system'

interface EvoSelectProps {
  value: any | null
  onChange: (selectedItem: any) => void
  options: any[]
  size: any
  isSearchable: boolean
  isClearable?: boolean
  disabled?: boolean
}

export default function EvoSelect({
  value,
  onChange,
  options,
  size,
  isSearchable,
  isClearable,
  disabled,
}: EvoSelectProps) {
  return (
    <>
      <Select
        disabled={disabled}
        isSearchable={isSearchable}
        options={options}
        value={value}
        onChange={(selectedItem: any) => {
          onChange(selectedItem)
        }}
        size={size}
        isClearable={isClearable}
      />
      <div />
    </>
  )
}
